import React, { useEffect, useState, useRef } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../../context/authContext";
import { getServicioStyle } from "../../../utils/servicioColores";

const AutocompleteInput = ({ value, onChange, opciones, placeholder }) => {
  const [texto, setTexto] = useState(value);
  const [abierto, setAbierto] = useState(false);
  const ref = useRef(null);

  useEffect(() => { setTexto(value); }, [value]);

  useEffect(() => {
    const handler = (e) => { if (ref.current && !ref.current.contains(e.target)) setAbierto(false); };
    document.addEventListener("mousedown", handler);
    document.addEventListener("touchstart", handler);
    return () => { document.removeEventListener("mousedown", handler); document.removeEventListener("touchstart", handler); };
  }, []);

  const sugerencias = texto
    ? opciones.filter((o) => o.toLowerCase().includes(texto.toLowerCase()))
    : opciones;

  const seleccionar = (op) => { onChange(op); setTexto(op); setAbierto(false); };
  const limpiar = () => { onChange(""); setTexto(""); setAbierto(false); };

  return (
    <div ref={ref} style={{ position: "relative", display: "inline-flex", alignItems: "center" }}>
      <input
        type="text"
        placeholder={placeholder}
        value={texto}
        onChange={(e) => { setTexto(e.target.value); onChange(e.target.value); setAbierto(true); }}
        onFocus={() => setAbierto(true)}
        style={{ padding: "12px 40px 12px 14px", fontSize: 16, borderRadius: 10, border: "1.5px solid #ccc", width: 160, outline: "none", boxShadow: "0 1px 4px rgba(0,0,0,0.08)", WebkitAppearance: "none" }}
        autoComplete="off"
      />
      {texto && (
        <button onMouseDown={(e) => { e.preventDefault(); limpiar(); }} style={{ position: "absolute", right: 8, background: "#ef4444", border: "none", cursor: "pointer", color: "#fff", fontSize: 15, fontWeight: 700, width: 28, height: 28, borderRadius: "50%", display: "flex", alignItems: "center", justifyContent: "center", lineHeight: 1, padding: 0 }}>✕</button>
      )}
      {abierto && sugerencias.length > 0 && (
        <div style={{ position: "absolute", top: "100%", left: 0, zIndex: 999, background: "#fff", border: "1.5px solid #ccc", borderRadius: 10, boxShadow: "0 4px 16px rgba(0,0,0,0.15)", maxHeight: 220, overflowY: "auto", width: "100%", marginTop: 4 }}>
          {sugerencias.map((op) => (
            <div
              key={op}
              onMouseDown={(e) => { e.preventDefault(); seleccionar(op); }}
              onTouchEnd={(e) => { e.preventDefault(); seleccionar(op); }}
              style={{ padding: "12px 14px", fontSize: 16, cursor: "pointer", borderBottom: "1px solid #f0f0f0" }}
            >{op}</div>
          ))}
        </div>
      )}
    </div>
  );
};

const DIAS = [
  { key: "l", label: "L" },
  { key: "m", label: "M" },
  { key: "x", label: "X" },
  { key: "j", label: "J" },
  { key: "v", label: "V" },
  { key: "s", label: "S" },
];

const COLORES_RUTA = ["#4ECDC4", "#4CAF50", "#556270", "#C7F464", "#C44DFF", "#FFB347"];

const getColorRuta = (ruta, rutasUnicas) => {
  const idx = rutasUnicas.findIndex((r) => String(r) === String(ruta));
  return COLORES_RUTA[(idx === -1 ? 0 : idx) % COLORES_RUTA.length];
};

const getContrast = (hex) => {
  if (!hex) return "#000";
  const c = hex.replace("#", "");
  const r = parseInt(c.substring(0, 2), 16);
  const g = parseInt(c.substring(2, 4), 16);
  const b = parseInt(c.substring(4, 6), 16);
  return 0.2126 * r + 0.7152 * g + 0.0722 * b > 150 ? "#000" : "#fff";
};

const AdminSeguimientoServicios = () => {
  const [pisos, setPisos] = useState([]);
  const [busqueda, setBusqueda] = useState("");
  const [filtroRuta, setFiltroRuta] = useState("");
  const [filtroAsistenta, setFiltroAsistenta] = useState("");
  const [filtroSupervisora, setFiltroSupervisora] = useState("");
  const [loading, setLoading] = useState(true);

  const navigate = useNavigate();
  const { user: authUser } = useAuth();
  const rolActual = authUser?.tipo || '';
  const panelOrigen = (rolActual === 'superadmin')
    ? '/superadmin/servicios'
    : '/admin';

  useEffect(() => {
    axios
      .get("/api/pisoCrearCompras/pisos_admin_servicios")
      .then((res) => setPisos(Array.isArray(res.data) ? res.data : []))
      .catch(() => setPisos([]))
      .finally(() => setLoading(false));
  }, []);

  const rutasUnicas = [...new Set(pisos.map((p) => p.ruta))].sort((a, b) => a - b);
  const asistentasUnicas = [...new Set(pisos.map((p) => p.nombre_asistenta).filter(Boolean))].sort();
  const supervisorasUnicas = [...new Set(pisos.map((p) => p.user_supervisora).filter(Boolean))].sort();

  const pisosFiltrados = pisos.filter(
    (p) =>
      (busqueda === "" || p.abreviatura.toLowerCase().includes(busqueda.toLowerCase())) &&
      (filtroRuta === "" || String(p.ruta) === filtroRuta) &&
      (filtroAsistenta === "" || (p.nombre_asistenta || "").toLowerCase().includes(filtroAsistenta.toLowerCase())) &&
      (filtroSupervisora === "" || (p.user_supervisora || "").toLowerCase().includes(filtroSupervisora.toLowerCase()))
  );

  const irAOrganizar = (piso) => {
    navigate("/admin/organizarServicio", {
      state: { piso, supervisora: piso.user_supervisora },
    });
  };

  if (loading) return <p style={{ textAlign: "center", marginTop: 60 }}>Cargando pisos…</p>;

  return (
    <div style={{ maxWidth: 680, margin: "0 auto", padding: "20px" }}>
      {/* Cabecera */}
      <div style={{ display: "flex", alignItems: "center", marginBottom: 20, gap: 12 }}>
        <button onClick={() => navigate(panelOrigen)} style={styles.btnVolver}>
          ← Volver
        </button>
        <h2 style={{ flex: 1, textAlign: "center", fontSize: 30, margin: 0, fontWeight: 900, color: "#1e3a5f", letterSpacing: "-0.5px" }}>
          Seguimiento Servicios
        </h2>
      </div>

      {/* Filtros */}
      <div style={{ display: "flex", gap: 10, marginBottom: 24, justifyContent: "center", flexWrap: "wrap" }}>
        <AutocompleteInput
          value={busqueda}
          onChange={setBusqueda}
          opciones={[...new Set(pisos.map((p) => p.abreviatura))].sort()}
          placeholder="Buscar piso…"
        />
        <AutocompleteInput
          value={filtroAsistenta}
          onChange={setFiltroAsistenta}
          opciones={asistentasUnicas}
          placeholder="Buscar asistenta…"
        />
        <AutocompleteInput
          value={filtroSupervisora}
          onChange={setFiltroSupervisora}
          opciones={supervisorasUnicas}
          placeholder="Buscar supervisora…"
        />
        <select
          value={filtroRuta}
          onChange={(e) => setFiltroRuta(e.target.value)}
          style={{
            ...styles.inputFiltro,
            background: filtroRuta ? getColorRuta(filtroRuta, rutasUnicas) : "#fff",
            color: filtroRuta ? getContrast(getColorRuta(filtroRuta, rutasUnicas)) : "#111",
            WebkitAppearance: "none",
          }}
        >
          <option value="">Rutas (todas)</option>
          {rutasUnicas.map((r) => (
            <option key={r} value={r} style={{ background: getColorRuta(r, rutasUnicas), color: "#fff" }}>
              Ruta {r}
            </option>
          ))}
        </select>
      </div>

      {/* Tarjetas */}
      {pisosFiltrados.length === 0 ? (
        <p style={{ textAlign: "center", color: "#888", marginTop: 30 }}>No se encontraron pisos.</p>
      ) : (
        pisosFiltrados.map((piso) => {
          const colorRuta = getColorRuta(piso.ruta, rutasUnicas);
          const diasConHorario = DIAS.filter(
            (d) => piso[`${d.key}_e`] || piso[`${d.key}_s`]
          );
          return (
            <div
              key={piso.id}
              onClick={() => irAOrganizar(piso)}
              style={{ ...styles.card, borderLeft: `5px solid ${colorRuta}` }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = "scale(1.02)";
                e.currentTarget.style.boxShadow = "0 6px 18px rgba(0,0,0,0.15)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = "scale(1)";
                e.currentTarget.style.boxShadow = "0 3px 8px rgba(0,0,0,0.1)";
              }}
            >
              {/* Fila superior: abreviatura + ruta */}
              <div style={styles.cardTop}>
                <span style={styles.abreviatura}>{piso.abreviatura}</span>
                <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                  <span
                    style={{
                      ...styles.badgeRuta,
                      background: colorRuta,
                      color: getContrast(colorRuta),
                    }}
                  >
                    Ruta {piso.ruta}
                  </span>
                  <span style={styles.arrow}>→</span>
                </div>
              </div>

              {/* Supervisora */}
              {piso.user_supervisora && (
                <div style={styles.supervisoraRow}>
                  <span style={styles.supervisoraLabel}>Supervisora:</span>
                  <span style={styles.supervisoraNombre}>{piso.user_supervisora}</span>
                </div>
              )}

              {/* Asistenta */}
              {piso.nombre_asistenta && (
                <div style={styles.asistentalRow}>
                  <span style={styles.asistentalNombre}>{piso.nombre_asistenta}</span>
                  {piso.horas_dia && (
                    <span style={styles.horas}>{piso.horas_dia}h/día</span>
                  )}
                </div>
              )}

              {/* Horario semanal + Servicio */}
              {diasConHorario.length > 0 && (
                <div style={{ ...styles.horarioRow, flexWrap: "wrap", alignItems: "center" }}>
                  {diasConHorario.map((d) => (
                    <div key={d.key} style={styles.diaItem}>
                      <span style={styles.diaLabel}>{d.label}</span>
                      <span style={styles.diaHora}>
                        {(piso[`${d.key}_e`] || "--").slice(0, 5)}
                      </span>
                      <span style={styles.diaHora}>
                        {(piso[`${d.key}_s`] || "--").slice(0, 5)}
                      </span>
                    </div>
                  ))}
                  {piso.servicio && (() => {
                    const sc = getServicioStyle(piso.servicio);
                    return (
                      <span style={{ ...styles.badgeServicio, background: sc.bg, color: sc.color, border: `1px solid ${sc.border}`, marginLeft: 6 }}>
                        {piso.servicio}
                      </span>
                    );
                  })()}
                </div>
              )}
              {/* Servicio sin horario */}
              {diasConHorario.length === 0 && piso.servicio && (() => {
                const sc = getServicioStyle(piso.servicio);
                return (
                  <div>
                    <span style={{ ...styles.badgeServicio, background: sc.bg, color: sc.color, border: `1px solid ${sc.border}` }}>
                      {piso.servicio}
                    </span>
                  </div>
                );
              })()}

              {/* Estado cierre de hoy */}
              {piso.cerrado === 1 && piso.cerrado_por && (
                <div style={{ display: "flex", alignItems: "center", gap: 10, background: "linear-gradient(135deg, #dcfce7, #bbf7d0)", borderRadius: 10, padding: "10px 14px", border: "1.5px solid #4ade80" }}>
                  <span style={{ fontSize: 22 }}>✅</span>
                  <div style={{ flex: 1 }}>
                    <div style={{ fontSize: 13, color: "#16a34a", fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.07em" }}>Cerrado hoy</div>
                    <div style={{ fontSize: 18, fontWeight: 800, color: "#14532d" }}>
                      {piso.hora_cierre && <span style={{ marginRight: 8 }}>🕐 {piso.hora_cierre}h</span>}
                      {piso.cerrado_por}
                    </div>
                    {(piso.n_hechos > 0 || piso.n_no_hechos > 0) && (
                      <div style={{ display: 'flex', gap: 6, marginTop: 4 }}>
                        {piso.n_hechos > 0 && <span style={{ fontSize: 13, background: '#dcfce7', color: '#15803d', borderRadius: 8, padding: '2px 9px', fontWeight: 800, border: '1px solid #86efac' }}>✅{piso.n_hechos}</span>}
                        {piso.n_no_hechos > 0 && <span style={{ fontSize: 13, background: '#fee2e2', color: '#dc2626', borderRadius: 8, padding: '2px 9px', fontWeight: 800, border: '1px solid #fca5a5' }}>❌{piso.n_no_hechos}</span>}
                      </div>
                    )}
                  </div>
                </div>
              )}
              {piso.cerrado === 0 && (
                <div style={{ display: "flex", alignItems: "center", gap: 10, background: "linear-gradient(135deg, #fef9c3, #fef08a)", borderRadius: 10, padding: "10px 14px", border: "1.5px solid #fbbf24" }}>
                  <span style={{ fontSize: 22 }}>🟡</span>
                  <div style={{ fontSize: 17, color: "#92400e", fontWeight: 800 }}>En curso hoy</div>
                </div>
              )}
            </div>
          );
        })
      )}
    </div>
  );
};

const styles = {
  btnVolver: {
    padding: "8px 18px", borderRadius: 20,
    background: "linear-gradient(135deg, #3b82f6, #1d4ed8)",
    color: "#fff", border: "none", cursor: "pointer",
    fontWeight: 700, fontSize: 14, whiteSpace: "nowrap",
    boxShadow: "0 2px 6px rgba(29,78,216,0.3)",
  },
  inputFiltro: {
    padding: "12px 40px 12px 14px", fontSize: 16, borderRadius: 10,
    border: "1.5px solid #ccc", width: 160, outline: "none",
    boxShadow: "0 1px 4px rgba(0,0,0,0.08)",
    WebkitAppearance: "none",
  },
  inputWrapper: {
    position: "relative", display: "inline-flex", alignItems: "center",
  },
  btnClear: {
    position: "absolute", right: 8,
    background: "#ef4444", border: "none", cursor: "pointer",
    color: "#fff", fontSize: 15, fontWeight: 700,
    width: 28, height: 28, borderRadius: "50%",
    display: "flex", alignItems: "center", justifyContent: "center",
    lineHeight: 1, padding: 0,
  },
  card: {
    marginBottom: 16, borderRadius: 16, cursor: "pointer",
    background: "linear-gradient(135deg, #f0f4ff 0%, #e8f0fe 100%)",
    boxShadow: "0 4px 18px rgba(30,58,95,0.13)",
    transition: "transform 0.2s, box-shadow 0.2s",
    overflow: "hidden",
    padding: "16px 20px",
    display: "flex", flexDirection: "column", gap: 10,
    border: "1px solid #dde8fb",
  },
  cardTop: {
    display: "flex", justifyContent: "space-between", alignItems: "center",
  },
  abreviatura: { fontSize: 34, fontWeight: 900, color: "#1e3a5f", letterSpacing: "-0.5px" },
  badgeServicio: {
    padding: "5px 16px", borderRadius: 12,
    fontSize: 17, fontWeight: 700, letterSpacing: "0.4px",
    display: "inline-block",
  },
  badgeRuta: {
    padding: "6px 16px", borderRadius: 8,
    fontWeight: 800, fontSize: 16, minWidth: 60, textAlign: "center",
  },
  arrow: { fontSize: 22, color: "#3b82f6" },
  supervisoraRow: {
    display: "flex", alignItems: "center", gap: 6,
    background: "#f0e6ff", borderRadius: 8, padding: "4px 10px",
    border: "1px solid #d8b4fe",
  },
  supervisoraLabel: { fontSize: 14, fontWeight: 700, color: "#7c3aed" },
  supervisoraNombre: { fontSize: 16, fontWeight: 700, color: "#5b21b6" },
  asistentalRow: {
    display: "flex", alignItems: "center", gap: 8,
    background: "#fff", borderRadius: 10, padding: "8px 12px",
    border: "1px solid #dde3f0",
    boxShadow: "0 1px 4px rgba(30,58,95,0.06)",
  },
  asistentalNombre: { fontSize: 20, fontWeight: 700, color: "#1e3a5f", flex: 1 },
  horas: {
    fontSize: 14, background: "#e0f2fe", color: "#0369a1",
    padding: "3px 10px", borderRadius: 10, fontWeight: 700,
  },
  horarioRow: {
    display: "flex", flexWrap: "wrap", gap: 6,
  },
  diaItem: {
    display: "flex", flexDirection: "column", alignItems: "center",
    background: "#fff", border: "1.5px solid #bdd7f8",
    borderRadius: 10, padding: "6px 10px", minWidth: 48,
    boxShadow: "0 1px 5px rgba(59,130,246,0.10)",
  },
  diaLabel: { fontSize: 16, fontWeight: 900, color: "#3b82f6" },
  diaHora: { fontSize: 13, color: "#374151", fontWeight: 600 },
};

export default AdminSeguimientoServicios;
